<!--  -->
<template>
  <div :class="['myIndent', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <common-title titleName="我的订单" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <van-tabs title-active-color="#FF6C02" color="#FF6C02" line-width="22.5px" line-height="2.5px" v-model="activeName"
      swipeable @click="onClick">
      <van-tab v-for="(pages, index) in pages" :key="index" :name="pages.name" :title="pages.label">
        <div class="myIndent--body">
          <div class="login" v-if="!userInfo.id && isMiniProgram" >
            <img :src="require('@/assets/img/noData/noIndentH5.png')" alt="">
            <div class="loginBtn" @click="goLogin">立即登陆</div>
          </div>
          <components :is="pages.title" v-if="(!isMiniProgram || userInfo.id && isMiniProgram) && pages.name == activeName"></components>
        </div>
      </van-tab>
    </van-tabs>
    <Foot />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import { whatEev } from '@/utils/tools';
import Foot from '@/components/foot/privacy.vue';
import wx from 'weixin-js-sdk';
import AllIndent from './allIndent/allIndent.vue';
import UnpaidIndent from './unpaidIndent/unpaidIndent.vue';
import FinishIndent from './finishIndent/finishIndent.vue';
import ClosedIndent from './closedIndent/closedIndent.vue';

export default {
  data() {
    return {
      activeName: 0,
      nowPage: 0,
      fromName: '',
      isMiniProgram: false,
      pages: [
        {
          title: 'AllIndent',
          name: 0,
          label: '全部',
        },
        {
          title: 'UnpaidIndent',
          name: 1,
          label: '待支付',
        },
        {
          title: 'FinishIndent',
          name: 2,
          label: '已完成',
        },
        {
          title: 'ClosedIndent',
          name: 3,
          label: '已关闭',
        },
      ],
      scroll: null,
    };
  },

  components: {
    CommonTitle,
    AllIndent,
    UnpaidIndent,
    FinishIndent,
    ClosedIndent,
    Foot,
  },

  computed: {
    ...mapState(['userInfo']),
  },

  mounted() { },

  created() {
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
    }
  },
  watch: {
    userInfo: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal.id) {
          const list = ['indentDetail', 'shippedOrder', 'address'];
          if (list.indexOf(this.fromName) === -1) {
            sessionStorage.removeItem('activeName');
            this.activeName = 0;
          }
          this.refresh();
        } else if (whatEev() === 'miniprogram') {
          this.isMiniProgram = true;
        } else if (this.$root.$data.isApp) {
          console.log('不干别的');
        } else {
          this.$router.push({
            path: '/registrationLogin',
            query: { redirect: '/personalCenter/myIndent' },
          });
        }
        // this.onClickGetCouon();
      },
    },
  },

  methods: {
    // 刷新显示当前标签
    refresh() {
      this.activeName = parseInt(sessionStorage.getItem('activeName'), 0);
    },
    // 切换标签
    onClick(name) {
      this.activeName = name;
      sessionStorage.setItem('activeName', name);
    },
    goLogin() {
      const path = '/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=/subPackages/orderCenter/index';
      wx.miniProgram.redirectTo({
        url: path,
      });
    },
  },
  // beforeRouteLeave(to, from, next) {
  //   // 如果在window中出现的滚动条
  //   this.scroll = document.documentElement.scrollTop;
  //   next();
  // },
  // 进入路由之前执行的函数
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const that = vm;
      that.fromName = from.name;
      // const list = ['indentDetail', 'shippedOrder', 'address'];
      // if (list.indexOf(from.name) === -1) {
      //   const that = vm;
      //   sessionStorage.removeItem('activeName');
      //   that.activeName = 0;
      // }
      // 如果在window中出现的滚动条
      // document.documentElement.scrollTop = vm.scroll;
    });
  },
};
</script>
<style lang="scss" scoped>
.myIndent {
  width: 100%;
  height: 100%;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #f9f9f9;

  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }

  ::v-deep .van-tab__text--ellipsis {
    width: 100%;
    text-align: center;
    border-right: 1px solid #e1e1e1;
  }

  ::v-deep .van-tab:nth-of-type(4) {
    .van-tab__text--ellipsis {
      width: 100%;
      text-align: center;
      border-right: none;
    }
  }

  ::v-deep .van-tabs {
    height: 100%;

    &__content {
      height: 100%;
    }
  }

  ::v-deep .van-tabs--line {
    .van-tabs__wrap {
      position: fixed;
      z-index: 500;
      width: 100%;
    }
  }

  ::v-deep .van-tab--active {
    font-size: 16px;
  }

  ::v-deep .van-tab__pane {
    // height: 100%;
  }

  &--body {
    height: 100%;
    padding: 100px 36px 10px;
    background: #f9f9f9ff;
  }
  .login {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 30%;
    p {
    // width: 174px;
    height: 40px;
    margin: 20px 0 30px;
    color: #a5a5a5;
    font-weight: 400;
    font-size: 29px;
    line-height: 40px;
  }
    img {
      width: 290px;
      //   height: 290px;
    }
  }
  .loginBtn {
    width: 400px;
    height: 80px;
    margin: 0 auto 0;
    color: #FFF;
    font-weight: 400;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #FF7F41;
    border-radius: 45px;
  }
}
</style>
